export const changeRainforestPremiumReducer = (state = null, action) => {
    switch (action.type) {
      case "CHANGE_RAINFORESTPREMIUM":
        return action.payload.rainforestPremium;
      default:
        return state;
    }
  };
  